import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useCopyToClipboard, useNotification } from '../../../../hooks'
import { stopPropagation } from '../../../../utils/events'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import {
  PROFILE_INFO_COPY_NOTIFICATION_KEY,
  PROFILE_INFO_COPY_RESET_TIMEOUT,
  PROFILE_INFO_COPY_TOOLTIP_KEY,
  QA_NAME_PROFILE_INFO_COPY_BUTTON,
} from '../ProfileInfoWidget.constants'

import CopyIcon from '../../../../icons/copy.svg'

function ProfileInfoWidgetItemCopyButton({ className, type, value }) {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const [copied, setCopied] = useState(false)

  const timerRef = useRef(null)

  const [, copy] = useCopyToClipboard({ onSuccess: handleSuccessCopy })

  useEffect(() => () => clearTimeout(timerRef.current), [])

  function handleSuccessCopy() {
    setCopied(true)

    handleAddSuccessNotification(PROFILE_INFO_COPY_NOTIFICATION_KEY[type])

    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      setCopied(false)
    }, PROFILE_INFO_COPY_RESET_TIMEOUT)
  }

  function handleClick(event) {
    stopPropagation(event)

    copy(value)
  }

  return (
    <Button.Outlined
      isGrey
      beforeIconProps={{ Icon: CopyIcon }}
      className={className}
      disabled={copied}
      height={BUTTON_HEIGHT_32}
      qaName={`${QA_NAME_PROFILE_INFO_COPY_BUTTON}_${type}`}
      tooltip={t(
        copied
          ? PROFILE_INFO_COPY_TOOLTIP_KEY.copied
          : PROFILE_INFO_COPY_TOOLTIP_KEY[type]
      )}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClick}
    />
  )
}

export default ProfileInfoWidgetItemCopyButton
